import { httpRequest } from "@services/http";
import { Credit } from "@models/credit.model";
import { CreditSerializer } from "@models/serializers/creditSerializer";

export interface UpdateCreditPayload {
  budget_id?: number;
  amount?: number;
  effective_date?: string | null;
  source_type?: string;
  reason?: string | null;
}

export class CommandUpdateCredit {
  async run(contractId: number, creditId: number, payload: UpdateCreditPayload): Promise<Credit> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/credits/${creditId}/`;
    const response = await httpRequest<any>(url, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
    return CreditSerializer.fromJson(response);
  }
}
